'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickReplies = exports.getQuickReply = exports.getAllowMultiSelect = exports.getAllowUserInput = exports.getUrl = exports.getText = exports.getId = exports.getType = exports.getTimestamp = exports.getThreadId = exports.getStatus = exports.getSource = exports.getSenderType = exports.getSenderId = exports.getMetadata = exports.getDescriptor = exports.getAuditTimestamp = exports.getAgentId = undefined;
exports.getRichText = getRichText;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _underscore = require('underscore');

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAgentId = exports.getAgentId = (0, _getIn2.default)(_keyPaths.METADATA_AGENT_ID);
var getAuditTimestamp = exports.getAuditTimestamp = (0, _getIn2.default)(_keyPaths.METADATA_AUDIT_TIMESTAMP);
var getDescriptor = exports.getDescriptor = (0, _getIn2.default)(_keyPaths.DESCRIPTOR);
var getMetadata = exports.getMetadata = (0, _getIn2.default)(_keyPaths.METADATA);
var getSenderId = exports.getSenderId = (0, _pipe2.default)((0, _getIn2.default)(_keyPaths.SENDER_ID), function (senderId) {
  return senderId && '' + senderId;
});
var getSenderType = exports.getSenderType = (0, _getIn2.default)(_keyPaths.SENDER_TYPE);
var getSource = exports.getSource = (0, _getIn2.default)(_keyPaths.DESCRIPTOR_SOURCE);
var getStatus = exports.getStatus = (0, _getIn2.default)(_keyPaths.DESCRIPTOR_STATUS);
var getThreadId = exports.getThreadId = (0, _getIn2.default)(_keyPaths.THREAD_ID);
var getTimestamp = exports.getTimestamp = (0, _getIn2.default)(_keyPaths.TIMESTAMP);
var getType = exports.getType = (0, _getIn2.default)(_keyPaths.METADATA_TYPE);
var getId = exports.getId = (0, _getIn2.default)(_keyPaths.ID);
var getText = exports.getText = (0, _getIn2.default)(_keyPaths.TEXT);
var getUrl = exports.getUrl = (0, _getIn2.default)(_keyPaths.URL);
var getAllowUserInput = exports.getAllowUserInput = (0, _getIn2.default)(_keyPaths.ALLOW_USER_INPUT);
var getAllowMultiSelect = exports.getAllowMultiSelect = (0, _getIn2.default)(_keyPaths.ALLOW_MULTI_SELECT);
var getQuickReply = exports.getQuickReply = (0, _getIn2.default)(_keyPaths.QUICK_REPLY);
var getQuickReplies = exports.getQuickReplies = (0, _getIn2.default)(_keyPaths.QUICK_REPLIES);

function getRichText(message) {
  return (0, _getIn2.default)(_keyPaths.RICH_TEXT, message) || (0, _underscore.escape)(getText(message));
}